import { Scale } from "~/OnboardingApp/components";
import { CoverageLevel } from "~/OnboardingApp/pages/questionPages/CoveragePage";
import { HasHealthConditions } from "~/OnboardingApp/pages/questionPages/HealthConditionsPage/HealthConditionsPage";
import { HowDidYouHear } from "~/OnboardingApp/pages/questionPages/HowDidYouHearPage/HowDidYouHearPage";
import { HasMedicalDiagnosis } from "~/OnboardingApp/pages/questionPages/MedicalDiagnosisPage";
import { Partner } from "~/OnboardingApp/pages/questionPages/PartnerPage";
import { Length } from "~/OnboardingApp/utils";
import { PlanType, Provider } from "./types";

const url = "/api/v1/onboarding";

export type Onboarding = {
  acceptedAdditionalTerms: boolean;
  acceptedTerms: boolean;
  biggestChallenge: string;
  bornOn: string;
  chronicConditions: string;
  clinicSatisfaction: Scale;
  curiousAbout: string[];
  dueDate: string;
  email: string;
  employer: string;
  fertilityCoverage: CoverageLevel;
  fertilityCoverageOther: string;
  firstName: string;
  hasChronicConditions: HasHealthConditions;
  hasMedicalConditions: HasMedicalDiagnosis;
  howAnxious: Scale;
  howDidYouHear: HowDidYouHear;
  howGrateful: Scale;
  howOptimistic: Scale;
  howSupported: Scale;
  international: boolean;
  journeyLooksLike: string[];
  journeyOtherDetails: string;
  upcomingMilestone: string;
  upcomingMilestoneDate: string;
  lastName: string;
  lengthOfTimeTtc: Length;
  onboardingSource: string;
  otherDetails: string;
  partner: Partner;
  partnerEmail: string | null;
  phone: string;
  planType: PlanType;
  pregnancyBackground: string[];
  pregnancyOtherDetails: string;
  providersOtherDetails: string;
  providersSeen: string[];
  providerId: string;
  relevantMedicalConditions: string;
  supportNeeds: string[];
  supportNeedsOtherDetails: string;
  thingsToSupport: string;
  zipCode: string;
  providers: Provider[];
};

interface OnboardingSerializer {
  data: {
    attributes: Onboarding;
  };
}

export type OnboardingIndexResponse = OnboardingSerializer;

export const onboardingIndexQuery = () => ({
  url,
  method: "GET",
});

export type OnboardingUpdateParams = Partial<Onboarding>;
export type OnboardingUpdateResponse = OnboardingIndexResponse;

export const onboardingUpdateQuery = (params: OnboardingUpdateParams) => ({
  url,
  method: "PATCH",
  body: params,
});
